import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { ResourceTasksTable } from '@mercadoni/gungnir'
import { observer } from 'mobx-react-lite'
import { useResourceProfileStore } from './resource-profile.context'
import { getTasksStores, mapTaskToJobMap, mapResourceMap } from './resource-profile.tools'
import JobModal from '@/shared/job-modal'
import { getJobByUUID } from '@/domain/jobs/jobs.services'
import './resource-profile.styles.less'
import { useHistory, useLocation } from 'react-router-dom'
import { Map } from '../../Main/Components/Gungir/components/map/map'

const StatusTab = (props) => {
  const { resourceId, resourceInfo } = props
  const history = useHistory()
  const location = useLocation()
  const [selectedJob, setSelectedJob] = useState(null)
  const [showJobModal, setShowJobModal] = useState(false)
  const [mapJobResource, setMapJobResource] = useState(null)
  const [selectedTaskId, setSelectedTaskId] = useState()
  const [tablePagination, setTablePagination] = useState({
    current: 1,
    defaultPageSize: 20,
    pageSize: 5,
    showSizeChanger: false
  })
  const { t } = useTranslation()
  const store = useResourceProfileStore()
  const [showMap, setShowMap] = useState(false)

  const lastUpdatePosition = store.resourceInfo && store.resourceInfo.last_update
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientTimezone = userInfo.user.client.timeZone

  const cleanMap = () => {
    setMapJobResource(null)
    setSelectedTaskId('')
  }

  const handleModal = () => {
    setShowJobModal(!showJobModal)
  }

  const onClickReference = async (jobUuid) => {
    const completeJob = await getJobByUUID(jobUuid)
    if (!completeJob) return
    let newPathName = null
    if (/\/orders\/[^/]+$/.test(location.pathname)) {
      const currentPathName = location.pathname
      newPathName = currentPathName.replace(/\/orders\/[^/]+$/, `/orders/${completeJob.id}`)
    } else {
      newPathName = `${location.pathname}/orders/${completeJob.id}`
    }

    setSelectedJob(completeJob)
    handleModal()
    history.push(newPathName)
  }

  const onClickShowInMap = (task) => {
    const {
      id,
      origin: { name, latitude, longitude }
    } = task
    if (selectedTaskId === id) {
      cleanMap()
    } else {
      setSelectedTaskId(id)
      setMapJobResource({
        job: mapTaskToJobMap(task, onClickReference),
        store: {
          name,
          location: [latitude, longitude]
        },
        resource: mapResourceMap(store.resourceInfo)
      })
    }
  }

  const onTableChange = async (pagination) => {
    const { current, pageSize, total } = pagination
    await store.loadAssignedTasks(resourceId, pageSize, (current - 1) * pageSize)
    setTablePagination({
      ...tablePagination,
      total,
      current
    })
    cleanMap()
  }

  const columnNames = [
    {
      title: '',
      dataIndex: 'show_in_map'
    },
    {
      dataIndex: 'job_number',
      title: t('jobNumber'),
      width: 100
    },
    {
      dataIndex: 'task_type',
      title: t('tasks'),
      render: (record) => t(record),
      width: 100
    },
    {
      title: t('store'),
      dataIndex: 'store',
      width: 100
    },
    {
      dataIndex: 'status',
      title: t('status')
    }
  ]

  const resourceTasksTableProps = {
    columnNames,
    copy: t,
    onClickReference,
    onClickShowInMap,
    onTableChange,
    pagination: tablePagination,
    selectedTaskId
  }

  const mapProps = {
    timezone: clientTimezone
  }

  const { last_position, first_name, last_name, id } = resourceInfo
  const resource = {
    id: id,
    first_name: first_name,
    last_name: last_name,
    latitude: last_position?.latitude,
    longitude: last_position?.longitude,
    selected: true
  }

  if (last_position) {
    mapProps.resources = [resource]
    mapProps.initialCenter = [resource.latitude, resource.longitude]
  }

  if (store.assignedTasks && store.assignedTasks.tasks.length > 0) {
    resourceTasksTableProps.tasks = store.assignedTasks.tasks
    resourceTasksTableProps.pagination = {
      ...tablePagination,
      total: store.assignedTasks.number_of_pages * tablePagination.pageSize
    }

    mapProps.stores = getTasksStores(store.assignedTasks.tasks)

    mapProps.jobs = store.assignedTasks.tasks.map((task) => mapTaskToJobMap(task, onClickReference))
    mapProps.initialCenter = mapProps.jobs[0].location
  }

  if (mapJobResource) {
    mapProps.mapJobResource = mapJobResource
    mapProps.jobs = [mapJobResource.job]
    mapProps.initialCenter = mapProps.jobs[0].location
  }
  const onShowMap = () => {
    setShowMap(!showMap)
  }

  return (
    <div className='resource-profile-status'>
      {lastUpdatePosition && (
        <div className='resource-profile-status-last-position'>
          <p>{t('lastReportedPosition')}</p>
          <p style={{ marginLeft: '4px' }}>{t('at', { time: dayjs(lastUpdatePosition).format('HH:mm') })}</p>
        </div>
      )}
      {!showMap && mapProps?.initialCenter && (
        <div style={{ position: 'relative' }} onClick={onShowMap}>
          <img
            src='https://odin-images-and-files-production.s3.amazonaws.com/map-image/Map.png'
            style={{ width: '600px', height: '300px' }}
          />
          <div className='textOnMap'>{t('resource-profile.click-on-map')}</div>
        </div>
      )}

      {showMap && mapProps?.initialCenter && <Map {...mapProps} />}

      <div className='resource-profile-status-assigned-tasks'>
        <span>{t('tasksCurrentlyAssigned')}</span>
      </div>
      <ResourceTasksTable {...resourceTasksTableProps} />
      <JobModal
        {...props}
        visible={showJobModal}
        handleModal={handleModal}
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        getJobsList={() => {}}
      />
    </div>
  )
}

export default observer(StatusTab)
